<template>
  <!-- #1210 · Indicador discreto del calendario de festivos sin cerrar. Se dibuja si y solo si
       Ajustes · Festivos está en el menú efectivo (regla de pantalla §9) y hay algo pendiente; no
       abre nada al cargar ni tapa la pantalla, y lleva directo al desglose. -->
  <f7-link
    v-if="visible"
    class="r-aviso-festivos"
    @click="abrir"
    :title="$t('festivos.avisos.indicadorTitulo')"
  >
    <i class="f7-icons r-aviso-festivos-icono">calendar</i>
    <span class="r-aviso-festivos-texto">{{ $tc('festivos.avisos.indicador', problemas, { n: problemas }) }}</span>
  </f7-link>
</template>

<script>
import Festivo from '../js/db/Festivo.js';
import RoutesUtils from '../js/RoutesUtils.js';
import UsuarioActualizado from '../js/usuarioActualizado.js';
import { EventBus } from '../js/EventBus';

/** Los mismos roles de repliegue que la ruta `/festivos/` (`pages/festivos/routes.js`). */
const ROLES_FESTIVOS = ['ADMIN', 'DIRECTOR'];

function sumaProblemas(avisos) {
  return (Array.isArray(avisos) ? avisos : []).reduce(function(total, a) {
    return total + ((a && a.problemas) || 0);
  }, 0);
}

export default {
  name: 'rAvisoFestivos',
  data() {
    return {
      puede: false,
      problemas: 0,
      sesionActual: 0,
      consultaActual: 0,
      // El último cálculo fresco de Ajustes · Festivos en esta sesión, si llegó antes que el permiso.
      avisosFrescos: null
    };
  },
  computed: {
    visible() {
      return this.puede && this.problemas > 0;
    }
  },
  methods: {
    comprobar() {
      const self = this;
      const sesion = ++self.sesionActual;
      self.avisosFrescos = null;
      // El permiso con el usuario de ESTA carga, no con el menú que quedó en localStorage de la
      // sesión anterior: es la misma espera que hace el Cuadro de mandos (`usuarioActualizado.js`).
      UsuarioActualizado.esperar().then(function(usuario) {
        if (sesion !== self.sesionActual) return;
        self.puede = !!usuario && RoutesUtils.tieneAcceso('/festivos/', ROLES_FESTIVOS);
        if (!self.puede) return;
        if (self.avisosFrescos) {
          self.problemas = sumaProblemas(self.avisosFrescos);
          return;
        }
        // La consulta lleva su propio turno: un cálculo fresco que llegue mientras está en vuelo
        // la deja sin efecto, porque la caché de minutos que ella lee es más vieja que ese cálculo.
        const consulta = ++self.consultaActual;
        return Festivo.avisos(false).then(function(avisos) {
          if (sesion !== self.sesionActual || consulta !== self.consultaActual) return;
          self.problemas = sumaProblemas(avisos);
        }, function() {
          // Sin dato no se pinta: el indicador solo cuenta, y el detalle con su aviso de «no se
          // ha podido calcular» está en Ajustes · Festivos.
          if (sesion !== self.sesionActual || consulta !== self.consultaActual) return;
          self.problemas = 0;
        });
      }).catch(function() {
        if (sesion !== self.sesionActual) return;
        self.problemas = 0;
      });
    },
    alActualizar(avisos) {
      this.consultaActual++;
      this.avisosFrescos = avisos;
      if (this.puede) this.problemas = sumaProblemas(avisos);
    },
    // La cabecera vive fuera de la vista principal: se navega en ella, como hace InfoIcon.
    abrir() {
      const f7 = this.$f7;
      if (f7 && f7.views && f7.views.main) f7.views.main.router.navigate('/festivos/?avisos=1');
    },
    limpiar() {
      this.sesionActual++;
      this.consultaActual++;
      this.avisosFrescos = null;
      this.puede = false;
      this.problemas = 0;
    }
  },
  mounted() {
    this._alEntrar = () => this.comprobar();
    this._alSalir = () => this.limpiar();
    this._alActualizar = (avisos) => this.alActualizar(avisos);
    EventBus.$on('app:auth-ready', this._alEntrar);
    EventBus.$on('app:session:close', this._alSalir);
    // Ajustes · Festivos reparte su cálculo fresco: al validar un municipio, el número de aquí
    // cambia sin esperar a la siguiente entrada.
    EventBus.$on('festivos:avisos', this._alActualizar);
  },
  beforeDestroy() {
    EventBus.$off('app:auth-ready', this._alEntrar);
    EventBus.$off('app:session:close', this._alSalir);
    EventBus.$off('festivos:avisos', this._alActualizar);
  }
};
</script>

<style scoped>
.r-aviso-festivos {
  display: inline-flex;
  align-items: center;
  margin: 0 6px;
  padding: 2px 8px;
  border-radius: 12px;
  background: #fff3e0;
  color: #8a5300;
  font-size: 12px;
  white-space: nowrap;
}
.r-aviso-festivos-icono {
  font-size: 16px;
  margin-right: 4px;
}
</style>
